import { z } from 'zod';
import { UserRole } from '../enums.js';
export const userSummary = z.object({
    id: z.number().int().positive(),
    email: z.string().email(),
    fullName: z.string(),
    role: UserRole,
    active: z.boolean(),
    lastLoginAt: z.string().datetime().nullable().optional(),
    createdAt: z.string().datetime(),
});
export const createUserRequest = z.object({
    email: z.string().email(),
    fullName: z.string().min(2),
    role: UserRole,
    password: z.string().min(10),
});
export const updateUserRequest = z.object({
    fullName: z.string().min(2).optional(),
    role: UserRole.optional(),
    active: z.boolean().optional(),
});
/** Leerer String aus einem Query-String bedeutet „kein Filter", nicht „leer suchen". */
const optionalTerm = (max) => z
    .string()
    .trim()
    .max(max)
    .optional()
    .transform((v) => (v ? v : undefined));
/**
 * Query der Benutzerliste.
 *
 * `search` sucht als Teiltreffer über Name UND E-Mail (case-insensitive);
 * `role` und `active` grenzen zusätzlich ein. Die drei sind UND-verknüpft —
 * „alle inaktiven Freigeber namens Berger" ist damit eine Abfrage.
 */
export const userListQuery = z.object({
    search: optionalTerm(200),
    role: UserRole.optional(),
    active: z
        .union([z.literal('true'), z.literal('false'), z.boolean()])
        .transform((v) => (typeof v === 'string' ? v === 'true' : v))
        .optional(),
    limit: z.coerce.number().int().positive().max(200).default(50),
    offset: z.coerce.number().int().nonnegative().default(0),
});
